import { HttpService, resolveService } from "@reco-m/core";

export class UnitHttpService extends HttpService {
    constructor() {
        super("organization/unit");
    }

}

export const unitService = resolveService(UnitHttpService);